import styled from 'styled-components'

export const StyledChangePasswordForm = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 32px;
  width: 100%;
  margin-top: 120px;
`

export const ChangePasswordPageTitle = styled.div`
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: center;
  color: #202020;
  margin-bottom: 20px;
`

export const ChangePasswordInputHint = styled.p`
  margin-bottom: 30px;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: #202020;
  opacity: 0.7;
`
